export const SET_UPDATE_LINK = 'SET_UPDATE_LINK'
export const SET_LINK_DETAILS = 'SET_LINK_DETAILS'
